module.exports = __webpack_public_path__ + "img/logo_black.b08392af.svg";